// Central contact info for Linked2Marketing. Update here to roll changes site-wide.

export const CALENDLY_URL = "https://calendly.com/contact-linked2marketing/30min";

export const EMAIL_ADDRESS = "contact@linked2marketing.com";
export const EMAIL_HREF = `mailto:${EMAIL_ADDRESS}`;

export const PHONE_DISPLAY = "+44 1943 512697";
export const PHONE_HREF = "tel:+441943512697";

// Common attrs for any outbound link
export const EXTERNAL_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
};
